import { render, staticRenderFns } from "./CreateEditRecipeModal.vue?vue&type=template&id=52205da3&"
import script from "./CreateEditRecipeModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditRecipeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports